import { primaryButton } from "../../components/ui/buttonStyles.js";
import { Ico } from "../../components/icons/icons.jsx";
import { ReportBuilderStepper } from "./ReportBuilderStepper.jsx";

export function ReportBuilderHeader({
  steps,
  activeStep,
  stepIndex,
  title,
  description,
  onStepClick,
  onPrev,
  onNext,
  canGoPrev,
  canGoNext,
  stepError,
  c,
  A,
  dark,
}) {
  return (
    <header style={{ flexShrink: 0, marginBottom: 12 }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16, marginBottom: 12 }}>
        <div style={{ minWidth: 0 }}>
          <p style={{ margin: "0 0 2px", fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: c.sub }}>
            Report builder
          </p>
          <h1 style={{ margin: "0 0 4px", fontSize: 18, fontWeight: 700, color: c.text }}>{title}</h1>
          <p style={{ margin: 0, fontSize: 12, color: c.sub, lineHeight: 1.5 }}>{description}</p>
        </div>
        <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
          <button
            type="button"
            onClick={onPrev}
            disabled={!canGoPrev}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              height: 36,
              padding: "0 12px",
              borderRadius: 8,
              border: `1px solid ${c.cardBdr}`,
              background: c.card,
              color: canGoPrev ? c.text : c.sub,
              fontSize: 13,
              fontWeight: 600,
              cursor: canGoPrev ? "pointer" : "not-allowed",
              opacity: canGoPrev ? 1 : 0.5,
            }}
          >
            {Ico.chevronLeft}
            Back
          </button>
          <button
            type="button"
            onClick={onNext}
            disabled={!canGoNext}
            style={{
              ...primaryButton(A, { dark }),
              opacity: canGoNext ? 1 : 0.5,
              cursor: canGoNext ? "pointer" : "not-allowed",
            }}
          >
            Continue
          </button>
        </div>
      </div>

      <ReportBuilderStepper steps={steps} activeStep={activeStep} stepIndex={stepIndex} onStepClick={onStepClick} c={c} A={A} />

      {stepError ? (
        <p style={{ margin: "10px 0 0", fontSize: 12, fontWeight: 600, color: "#EF4444" }}>{stepError}</p>
      ) : null}
    </header>
  );
}
